import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrow2DirectionsVertical = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.482 1.34109C10.0272 0.886303 9.28867 0.886303 8.83388 1.34109L5.34109 4.83388C4.8863 5.28867 4.8863 6.02724 5.34109 6.48203C5.79588 6.93682 6.53446 6.93682 6.98925 6.48203L8.49551 4.97577V15.6506L6.98925 14.148C6.53446 13.6932 5.79588 13.6932 5.34109 14.148C4.8863 14.6028 4.8863 15.3413 5.34109 15.7961L8.83388 19.2889C9.28867 19.7437 10.0272 19.7437 10.482 19.2889L13.9748 15.7961C14.4296 15.3413 14.4296 14.6028 13.9748 14.148C13.52 13.6932 12.7814 13.6932 12.3267 14.148L10.824 15.6506V4.97577L12.3303 6.48203C12.7851 6.93682 13.5237 6.93682 13.9785 6.48203C14.4332 6.02724 14.4332 5.28867 13.9785 4.83388L10.4857 1.34109H10.482Z",
		fill: "#0D2976"
	})
});
export default SvgArrow2DirectionsVertical;
